<template>
  <div>
  <b-button @click="showModal">{{ $dt('detections.create_samples', 'Create Samples') }}</b-button>

  <b-modal ref="modal"
          :hide-footer="true"
          @show="onShow()">
    <div slot="modal-title">
      <slot name="title"/>
      {{ $dt('detections.create_samples_title', 'Create Samples from Selection') }}({{ total }})
    </div>
    <slot name="body"/>
      <div class="modal-body">
        <div v-if="loading" class="text-center">
            <b-spinner type="grow" variant="primary" />
        </div>
        <form v-else @submit.prevent="onSubmit">
          <div class="mb-3">
            <label class="d-block mb-1">{{ $dt('detections.create_new_sample_set', 'Create New Sample Set') }}</label>
            <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="createSample" name="radiosBtn">
              <b-form-radio class="mx-0" :value="1">Yes</b-form-radio>
              <b-form-radio class="mx-0" :value="0">No</b-form-radio>
            </b-form-radio-group>
          </div>
          <div v-if="createSample" class="mb-3">
            <label>{{ $dt('detections.sample_set_name', 'Sample Set Name') }}</label>
            <b-form-input v-model="sampleSetName" />
          </div>
          <div v-else class="mb-3">
            <label>{{ $dt('detections.select_sample_set', 'Select Sample Set') }}</label>
            <treeselect :multiple="false" :searchable="true" :options="sampleSets" v-model="sampleSet" />
          </div>
          <div class="mb-3">
            <label class="d-block mb-1">{{ $dt('detections.copy_files', 'Copy Files') }}</label>
            <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="copyFiles" name="radiosBtn">
              <b-form-radio class="mx-0" :value="1">Yes</b-form-radio>
              <b-form-radio class="mx-0" :value="0">No</b-form-radio>
            </b-form-radio-group>
          </div>
          <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>
          <b-button type="submit" :disabled="submitting">
            <b-spinner v-if="submitting" type="grow" small />
            {{ $dt('global.create', 'Create') }}
          </b-button>

        </form>
      </div>
  </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
import Services from '@/services';

export default {
  name: 'CreateSamplesFromDetections',
  components: {
    Treeselect,
  },
  props: {
    filters: {
      type: Object,
      required: true
    },
    detectionSetId: {
      type: Number,
      required: true
    },
    selectedIds: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      modalValues: {
        id: 'create_samples_from_detections',
        btnSubmitText: 'Create',
        btnSubmitButtonClass: 'btn btn-primary',
        titleTxt: 'Create Samples',
        bodyTxt: 'Are you sure you want to create samples from selected detections?',
      },
      sampleSets: [],
      createSample: 1,
      copyFiles: 1,
      loading: true,
      loaded: false,
      sampleSet: null,
      sampleSetName: '',
      submitting: false,
      error: null,
    };
  },
  computed: {
    ...mapState('Auth', ['activeProjectId', 'token']),
  },
  watch: {
    activeProjectId() {
      this.loaded = false;
      this.loadSampleSets();
    },
  },
  methods: {
    loadSampleSets() {
      if (this.loaded) {
        return;
      }
      this.loading = true;
      Services.sampleSets.list(this.activeProjectId).then(({ data }) => {
        this.sampleSets = data.data.map((sampleSet) => {
          return {
            id: sampleSet.id,
            label: sampleSet.name,
          };
        });

        this.loading = false;
        this.loaded = true;
      }).catch((err) => {
        if (err.code !== 'ERR_CANCELED') {
          this.loading = false;
          this.loaded = true;
          console.log(err);
        }
      });
    },
    showModal() {
      this.$refs.modal.show();
    },
    onShow() {
      this.loadSampleSets();
    },
    onSubmit() {
      if (this.submitting) {
        return;
      }

      this.submitting = true;
      this.error = null;

      const params = {
        ...this.filters,
        create_params: {
          create_sample_set: this.createSample,
          copy_files: this.copyFiles,
          sample_set_id: this.sampleSet || null,
          sample_set_name: this.sampleSetName.length > 0 ? this.sampleSetName : null,
        }
      };

      if (this.selectedIds.length > 0) {
        params.ids = this.selectedIds;

        Services.detections.createSamplesFromIds(this.activeProjectId, this.detectionSetId, this.token, params).then((response) => {
          this.onSuccess(response);
        }).catch((err) => {
          this.onError(err);
        });
      } else {
        Services.detections.createSamples(this.activeProjectId, this.detectionSetId, this.token, params).then((response) => {
          this.onSuccess(response);
        }).catch((err) => {
          this.onError(err);
        });
      }
    },

    onSuccess(response) {
      this.$refs.modal.hide();
      this.error = null;
      this.alertSuccess({
        text: `${response.data?.count} ${this.$dt('detections.samples_created', 'Samples Created')}`,
      });
      this.submitting = false;
      this.$emit('created');
    },
    onError(err) {
      if (err.errors) {
        if (err.errors.create_params?.sample_set_id) {
          this.error = this.$dt('detections.select_sample_set', 'Select Sample Set');
        }
        if (err.errors.create_params?.sample_set_name) {
          this.error = this.$dt('detections.enter_sample_set_name', 'Enter Sample Set Name');
        }
      } else {
        this.error = 'An error occurred while creating samples.';
      }
      console.log(err);
      this.submitting = false;
    },
  },
};
</script>
